import request, { REQUEST_METHODS } from '@api/Request';
import { IpacEndpoints } from './config';
import { GetIpacSpeciesResponse, UpdatedGeometry, RequestBody } from './types';

export default class IpacService {
  public static readonly getSpeciesList = (updatedGeometry: UpdatedGeometry): Promise<GetIpacSpeciesResponse> => {
    const body: RequestBody = {
      'location.selectionMode': 'freedraw',
      'location.bufferDistance': 5,
      includeOtherFwsResources: true,
      includeCrithabGeometry: false,
    };

    if (updatedGeometry.isFootprint) {
      body['location.footprint'] = JSON.stringify(updatedGeometry);
    } else {
      body.projectLocationWKT = updatedGeometry.geoData;
    }

    return request({
      url: IpacEndpoints.getSpecies(),
      method: REQUEST_METHODS.POST,
      headers: { 'Content-Type': 'application/json' },
      data: body,
    });
  };
}
